import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesTypeDestination = {
  description: '',
  code: '',
  queueName: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const TypeDestinationInitializer = (): React.ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesTypeDestination}>
      <Outlet />
    </FilterTableProvider>
  );
};

TypeDestinationInitializer.displayName = 'Event destination page initializer component';

export default TypeDestinationInitializer;
